/**
 * lds-custom-tint.js
 * Bascule l'affichage entre le bloc d'achat et un formulaire de contact
 * "teinte sur-mesure" quand la variante correspondante est sélectionnée.
 *
 * L'état `isCustomTint` vit sur le wrapper Alpine racine du produit
 * (x-data du template). Ce helper se contente de le mettre à jour :
 *  - à l'init (état initial passé par Liquid)
 *  - à chaque changement de variante (event Eurus)
 *
 * @param {object} scope - le composant Alpine ($data) qui porte `isCustomTint`
 * @param {string} sectionId - id de la section produit
 * @param {string} tintValue - valeur d'option1 déclenchant le formulaire
 */
if (!window.Eurus.loadedScript.has('lds-custom-tint.js')) {
  window.Eurus.loadedScript.add('lds-custom-tint.js');

  window.ldsInitCustomTint = function (scope, sectionId, tintValue) {
    // L'event expose la variante courante après chaque sélection.
    document.addEventListener(
      `eurus:product-card-variant-select:updated:${sectionId}`,
      (e) => {
        const variant = e.detail && e.detail.currentVariant;
        const options = variant && variant.options;
        scope.isCustomTint = Array.isArray(options) && options[0] === tintValue;
        // Contenance courante (option2) pour l'injecter dans l'email.
        if (Array.isArray(options) && options.length > 1) {
          scope.customTintContenance = options[1];
        }
      }
    );
  };
}
